import { EndpointKey } from '../http/EndpointKey';
import { isEndOfFlow } from '../store/flow/selectors';
import { isEndpointStatusSuccess } from '../store/http-responses/selectors';
export const chatSpotOverrideRedirectCheck = state => {
  return isEndOfFlow(state) && isEndpointStatusSuccess(EndpointKey.Signup)(state) && isEndpointStatusSuccess(EndpointKey.LoginNewPortal)(state);
}; //add in check for tracking event